import { useEffect } from "react";

/**
 * Injects a <script type="application/ld+json"> tag into <head>
 * and removes it on unmount. Re-injects whenever the `data` prop changes.
 */
const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data) return undefined;
    const scriptId = `jsonld-${id}`;
    // Remove any existing tag with this id to avoid duplicates
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = scriptId;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [id, data]);

  return null;
};

export default JsonLd;
